// import * as React from "react";
import React, { useState, useEffect } from "react"

import Format from "../../atoms/format"

/**
 * Internal dependencies.
 */
import './_table.scss';


const TableToggleRows = ( props ) => {

	const tableID = props.tableID;
	const tableData = props.tableData;
	const tableType = props.tableType;
	const toggleType = props.toggleType;

	const [tableDataTotals, setTableDataTotals] = useState([]);

	// console.log('tableData.rows[tableData.rows.length - 1].cols', tableData.rows[tableData.rows.length - 1].cols );


	useEffect(() => {
		setTableDataTotals([...tableData.rows[tableData.rows.length - 1].cols]);
  }, []);


  // set atom class
  const atomClassName = 'table col-md-10'+ " is-type-"+tableType + " is-toggle-type-"+toggleType;
  var atomClass = props.className != undefined ? atomClassName + ' ' + props.className : atomClassName;

	const handleToggleRow = (event) => {

		event.currentTarget.closest('tr').classList.toggle('active');
		// update totals
		const totalsRow = event.currentTarget.closest('tbody').querySelector('tr:last-of-type');

		let totals = [];

		const totalsTDs = totalsRow.querySelectorAll('td');

		if (totalsTDs){
			totalsTDs.forEach((td, idx)=>{
				if (td.dataset.value){
					totals[idx] = td.dataset.value;
				}
			});
		}

		const activeRows = event.currentTarget.closest('tbody').querySelectorAll('tr:not(:last-of-type).active');

		const colsVals = [];

		// console.log('activeRows',activeRows);

		if (activeRows){

			activeRows.forEach((tr,trIdx) => {
				// get all tds
				const TDs = tr.querySelectorAll('td:not([data-format="spacer"])');

				if (TDs){

					TDs.forEach((td, tdIdx) => {
						// console.log('colsVals[tdIdx]',tdIdx,colsVals[tdIdx]);

						if (!colsVals[tdIdx]){ colsVals[tdIdx] = [] }

						if (!isNaN(parseFloat(td.dataset.value))){
							colsVals[tdIdx][trIdx] = parseFloat(td.dataset.value);
						}

					});
				}

			});
		}

		// update totals

		colsVals.forEach((col, idx) => {
			// sum all values in the col
			const sum = col.reduce((pv, cv) => pv + cv, 0);
			// change col total
			totals[idx] = sum;
		});

		// update totals row
		let newTotalsSum = JSON.parse(JSON.stringify( tableDataTotals ));

		totals.forEach((col, idx) => {
			newTotalsSum[idx].val = col;
		});

		setTableDataTotals(newTotalsSum);

		// console.log('colsVals',colsVals);
		// console.log('totals',totals);



	}

  return (
		<div className="table-wrap row">
			{
				tableData.notes && (
					<div className={`fs-13 mb-0 ${'' ?? tableData.notes.align}`}>{tableData.notes.content}</div>
				)
			}
			<table className={ atomClass } id={tableID}>
				{
					tableData.headers &&
					<thead>
						{ tableData.headers?.map((th,idx) => {
								return (

									th.cols &&
									<tr key={'table-head-' + idx}>
										{
											th.cols.map((thCol,tcIdx) => {
												// set default colspan = 1
												let colspan = 1;

												// if there is a colspan array...
												if (tableData.headers[idx].colspan){
													if (tableData.headers[idx].colspan[tcIdx]){
														// match current th to its colspan value
														colspan = tableData.headers[idx].colspan[tcIdx];
													}
												}
												return (
													<th key={'table-head-col-' + tcIdx} colSpan={colspan.toString()}>{thCol}</th>
												)
											})
										}
									</tr>

								)
							}) }
					</thead>
				}
				{
					tableData.rows &&
					<tbody>
						{
							tableData.rows?.map((dataRow,dataRowId) => {
								// console.log(dataRowId == tableData.rows.length - 1);
								return (
									dataRow && (dataRowId < tableData.rows.length-1) &&
										<tr key={'table-row-' + dataRowId} className="active">
											{
												dataRow.rowHeader != null && (
														<th>
														{ dataRowId < tableData.rows.length - 1 &&
															(<button className="row-toggler" onClick={handleToggleRow} />)
														}
														<span>{dataRow.rowHeader.val}</span>
														</th>
												)
											}
											{
												dataRow.cols.length > 0 &&
												dataRow.cols.map((dataCol,dataColIdx) => {
													let colspan = false;

													// if there is a colspan array...
													if (tableData.rows[dataRowId].colspan){
														if (tableData.rows[dataRowId].colspan[dataColIdx]){
															// match current th to its colspan value
															colspan = tableData.rows[dataRowId].colspan[dataColIdx];
														}
													}

													return (
														<td key={'table-row-col-' + dataColIdx} data-value={dataCol.val} {...(dataRowId == tableData.rows.length - 1 ? {'data-col-total': dataCol.val} : {})} colSpan={colspan.toString()} data-format={dataCol.format}>
															<Format dataVal={dataCol.val} dataType={dataCol.format} />
														</td>
													)

												})
											}
										</tr>
								)
							})
						}
						{
							tableDataTotals &&
								<tr className="active">
									<th>{tableData.rows[tableData.rows.length-1].rowHeader.val}</th>
									{
										tableDataTotals.map((dataCol,dataColIdx) => {
											return (
												<td key={'table-row-col-' + dataColIdx} data-value={dataCol.val} data-col-total={dataCol.val} data-format={dataCol.format}>
													<Format dataVal={dataCol.val} dataType={dataCol.format} />
												</td>
											)
										})
									}
								</tr>
						}
					</tbody>
				}
			</table>
		</div>
  )
}

export default TableToggleRows
